export default {
    createCampaign: 'Créer campagne',
    fetchingError: 'Erreur lors de la récupération des campagnes',
    searchPlaceholder: 'Rechercher campagne',
    viewButton: 'Voir',
    card: {
        createAt: 'Créée le:',
    },
};
